import { BASEMAPASLI } from "../../actions/portal/";

export default function(state = "OSM", action) {
  switch (action.type) {
    case BASEMAPASLI:
      return action.payload;
    default:
  }

  return state;
}
